// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Photos__row":"tc_a bhy_a bhy_r bhy_j","Photos__img":"tc_b bhy_b"};